/**
 * SuggestAnEdit — §10-D one-line mailto link for docs/articles/insights.
 *
 * Renders a small `Suggest an edit` link that opens a pre-populated email
 * with article slug + URL referenced in the subject. Cheapest possible
 * feedback loop — turns reviewers into contributors.
 *
 * Drop next to any long-form content block:
 *   <SuggestAnEdit articleSlug="insights/my-article" articleTitle="My Article" />
 */
import React from "react";
import { Edit3 } from "lucide-react";

const FEEDBACK_EMAIL = "info@ekselens.com";

export default function SuggestAnEdit({ articleSlug, articleTitle, className = "" }) {
  const subject = encodeURIComponent(
    `Suggest an edit · ${articleTitle || articleSlug || "ekselens.com article"}`,
  );
  const url = typeof window !== "undefined" ? window.location.href : "";
  const body = encodeURIComponent(
    `Hi Ekselens team,\n\nI'd like to suggest an edit to:\n  ${articleTitle || articleSlug}\n  ${url}\n\nMy proposed change:\n\n\n— Sent from the Suggest an edit link on ekselens.com\n`,
  );
  const href = `mailto:${FEEDBACK_EMAIL}?subject=${subject}&body=${body}`;
  return (
    <a
      href={href}
      className={`inline-flex items-center gap-1.5 text-[12px] tracking-[0.14em] uppercase text-zinc-500 hover:text-[#7737F6] transition-colors ${className}`}
      data-testid="suggest-an-edit"
      title="Open a pre-filled email so you can propose changes"
    >
      <Edit3 size={12} /> Suggest an edit
    </a>
  );
}
